import React from "react";
const CONTACT_EMAIL = "aulanova.digital@gmail.com";
export function Footer() {
  return <footer className="ft" data-id="element-60" data-mp="3gfsn6dua2wni">
      <div className="w" data-id="element-61" data-mp="3gg11ma61ua0t">
        <div className="ftop" data-id="element-62" data-mp="3ghc3g4fxp7pa">
          <div data-id="element-63" data-mp="32o4deh7i4k9p">
            <p className="fbrand" data-id="element-64" data-mp="32onj8zjvni7d">Equilíbrio 60+</p>
            <p className="fllc" data-id="element-65" data-mp="32lrm3dfusxjz">Orvantis Global LLC</p>
          </div>
          <nav className="flinks" aria-label="Links legais" data-id="element-66" data-mp="36q93x72nl0s4">
            <a href="/privacy-policy" data-id="element-67" data-mp="3ufa6wespvjq0">Privacy Policy</a>
            <a href="/terms-of-service" data-id="element-68" data-mp="3uftkxkf8xnyr">Terms of Service</a>
            <a href={`mailto:${CONTACT_EMAIL}`} data-id="element-69" data-mp="38zawx2kd95j">{CONTACT_EMAIL}</a>
          </nav>
        </div>
        <div className="flegal" data-id="element-70" data-mp="3lf58uv9exxoi">
          <h2 className="flt" data-id="element-71" data-mp="3ldu874b9l61m">Aviso Legal e Isenção de Responsabilidade</h2>
          <p data-id="element-72" data-mp="3qcdtr3ly4ftg">
            O Equilíbrio 60+ é um material educativo de apoio destinado a oferecer recursos complementares aos
            profissionais de saúde. Sua aplicação é de responsabilidade do usuário, devendo os profissionais habilitados
            utilizar o conteúdo conforme seu próprio critério técnico e a avaliação individual de cada paciente.
            Familiares e pessoas sem habilitação profissional devem consultar um fisioterapeuta ou outro profissional de
            saúde qualificado antes de aplicar qualquer exercício. O material não garante resultados específicos nem
            substitui a avaliação e a orientação profissional.
          </p>
        </div>
        <p className="fcopy" data-id="element-73" data-mp="828oa9xiabb9">© 2026 Equilíbrio 60+ · Orvantis Global LLC. All rights reserved.</p>
      </div>
    </footer>;
}